// Create new file: src/components/calendars/WorkoutPlanReferenceViewer.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Stack } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { DomainObjectModal } from '@platform/core/src/components/domain';
import { workoutPlanConfig } from '../../config/domainConfig';

const WorkoutPlanReferenceViewer = ({ resource, onActionSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!resource) {
    return <Typography variant="body2" color="text.secondary">Loading plan...</Typography>;
  }

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleModalActionSuccess = (action, item) => {
    // A plan being deleted from the modal should trigger a refresh.
    if (action === 'delete') {
      handleClose();
      if (onActionSuccess) {
        onActionSuccess(action, item);
      }
    }
  };

  return (
    <>
      <Paper
        variant="outlined"
        onClick={handleOpen}
        sx={{
          p: 1.5,
          cursor: 'pointer',
          width: '100%',
          '&:hover': {
            borderColor: 'primary.main',
            boxShadow: 1,
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <AssignmentIcon color="primary" />
          <Stack sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Typography variant="body1" fontWeight="medium" noWrap>
              {resource.name || 'Workout Plan'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Click to view details
            </Typography>
          </Stack>
        </Stack>
      </Paper>

      {isModalOpen && (
        <DomainObjectModal
          open={isModalOpen}
          onClose={handleClose}
          itemToEdit={resource}
          config={workoutPlanConfig}
          sectionTitle="Workout Plan Details"
          onActionSuccess={handleModalActionSuccess}
        />
      )}
    </>
  );
};

WorkoutPlanReferenceViewer.propTypes = {
  resource: PropTypes.object,
  onActionSuccess: PropTypes.func,
};

export default WorkoutPlanReferenceViewer;